module.exports = __webpack_public_path__ + "img/com61.05facf40.png";